export const MODULE_NAME = 'landing'

export const MODULE_TITLE = 'Landing'
